// extracted by mini-css-extract-plugin
module.exports = {"fixedBtn":"Button_fixedBtn__eF5wO","seBtn":"Button_seBtn__t2FIg"};